import { FirebaseError } from 'firebase/app';
import { AuthErrorCodes } from 'firebase/auth';

export const isPopupCancellation = (error: unknown) =>
  error instanceof FirebaseError &&
  ([AuthErrorCodes.POPUP_CLOSED_BY_USER, AuthErrorCodes.USER_CANCELLED] as string[]).includes(
    error.code,
  );
